import { CandidateProfileTableColumns } from 'modules/candidate-profile/tables/types/CandidateProfileTable';
import { TableV3Filters } from 'common/table/components/TableV3';
import { GetSearchCandidateProfileQueryQuery } from 'generated-graphql/hooks/apollo-hooks';
import { extractQueryGetItem } from 'core/utils/apollo/extractGetItem';
import { legacyTimeInRoleBandsToTableFilterItems } from 'modules/candidate-profile/tables/filters/legacyTimeInRoleBands';

export const convertQueryToTableFilters = (
  queryData: GetSearchCandidateProfileQueryQuery | undefined
): TableV3Filters<CandidateProfileTableColumns> | undefined => {
  const query = extractQueryGetItem(queryData);
  if (!query) return undefined;

  const searchFields: Partial<
    Record<keyof CandidateProfileTableColumns, string>
  > = {};
  const filterValues: Partial<
    Record<
      keyof CandidateProfileTableColumns,
      { label: string; value: string }[]
    >
  > = {};

  // Map search fields
  if (query.full_name) searchFields.name = query.full_name;
  if (query.current_company)
    searchFields.currentCompany = query.current_company;
  if (query.current_job_title)
    searchFields.currentJobTitle = query.current_job_title;
  if (query.email) searchFields.email = query.email;
  if (query.phone) searchFields.phone = query.phone;
  if (query.ats_candidate_id)
    searchFields.atsCandidateId = query.ats_candidate_id;
  if (query.original_source)
    searchFields.originalSource = query.original_source;

  // Map filter values
  if (query.time_in_role && query.time_in_role.length > 0) {
    const items = legacyTimeInRoleBandsToTableFilterItems(query.time_in_role);
    if (items.length > 0) filterValues.timeInRole = items;
  }

  if (query.skills && query.skills.length > 0) {
    filterValues.skills = query.skills.map((skill) => ({
      label: skill,
      value: skill
    }));
  }

  if (query.qualifications && query.qualifications.length > 0) {
    filterValues.qualifications = query.qualifications.map((qual) => ({
      label: qual,
      value: qual
    }));
  }

  if (query.tags && query.tags.length > 0) {
    filterValues.tags = query.tags.map((tag) => ({
      label: tag,
      value: tag
    }));
  }

  return {
    searchFields,
    filterValues
  } as TableV3Filters<CandidateProfileTableColumns>;
};
